module.exports = __webpack_public_path__ + "media/images/checkbox_checked-b6cfa4bd93f07086dab32235fc3744d2.svg";